import { ComponentInstall } from "../../utils";
import Label from "./src";

export default ComponentInstall(Label);
